import styles from './Button.scss';

import cx from 'classnames';
import React from 'react';

import { HasImage, HasLinkVariant, Link, LinkVariant } from 'src/api/contentful/contentTypes.cloverdotcom';
import { ContentImage } from 'src/components/ContentImage/ContentImage';
import { ContentLinkV2, ContentLinkV2Props } from 'src/components/ContentLinkV2/ContentLinkV2';
import { FlatEntry } from 'src/services/cms/flattenContentful';

export interface ButtonLinkV2Props<T extends FlatEntry<Link> = FlatEntry<HasLinkVariant & HasImage>> extends Omit<ContentLinkV2Props, 'entry'> {
  entry?: T;
  imageClassName?: string;
  isFullWidth?: boolean;
}

export const ButtonLinkV2 = React.forwardRef<HTMLAnchorElement, ButtonLinkV2Props>(((
  {
    className,
    imageClassName,
    isFullWidth,
    children,
    ...props
  }, ref) => {
  const { variant, image } = props.entry || {};
  const hasImage = !!image;

  const linkClassName = cx({
    [styles.buttonVariantPrimary]: variant === LinkVariant.PRIMARY,
    [styles.buttonVariantSecondary]: variant === LinkVariant.SECONDARY,
    [styles.buttonVariantText]: variant === LinkVariant.TEXT,
    [styles.buttonFullWidth]: isFullWidth,
    [styles.buttonImage]: hasImage,
  }, styles.button, className);

  return (
    <ContentLinkV2
      {...props}
      className={linkClassName}
      ref={ref}
      hideTitle={hasImage}
    >
      {image && <ContentImage entry={image} className={imageClassName} />}
      {children}
    </ContentLinkV2>
  );
}
));

ButtonLinkV2.displayName = 'ButtonLinkV2';
